/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_PriorityInputs */



/**
* | output |
* | --- |
* | "Priority Support" |
*
* @param {Signup_Compare_PriorityInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_priority = /** @type {((inputs?: Signup_Compare_PriorityInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_PriorityInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Priority Support")
	if (locale === "de") return /** @type {LocalizedString} */ ("Priority Support")
	if (locale === "it") return /** @type {LocalizedString} */ ("Priority Support")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Priority Support")
	if (locale === "es") return /** @type {LocalizedString} */ ("Priority Support")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Priority Support")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Priority Support")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Priority Support")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Priority Support")
	return /** @type {LocalizedString} */ ("Priority Support")
});